import { PacmanLoader } from 'react-spinners'

import { Container } from './styles'

const Loader = () => (
  <Container>
    <PacmanLoader color="yellow" />
  </Container>
)

export default Loader
